import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Menu, MenuApi } from 'src/app/shared/models/sidebar/sidebar.interface';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { QuickLinks, QuickLinksApi } from 'src/app/shared/models/header/quicklinks.interface';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {

  private approvalDialog =new Subject<any>();
  private aprvlCount = new BehaviorSubject<number>(0);
  private aprvlCounts$ = this.aprvlCount.asObservable();

  showApprovalsDialog(){
    this.approvalDialog.next({show: true});
  }

  getApprovalDialog(): Observable<any>{
    return this.approvalDialog.asObservable();
  }

  setAprvlCount(count: number){
    this.aprvlCount.next(count);
  }

  getAprvlCount(): Observable<number>{
    return this.aprvlCounts$;
  }

  constructor(private http: HttpClient) { }

  RoleMenu(paths: string): Observable<Menu[]>{
    return this.http.get<MenuApi>(`${environment.apiUrl}/get_role_menu/${paths}`).pipe(
      map((res) => res.data)
    );
  }

  getQuickLinks(): Observable<QuickLinks[]> {
    return this.http.get<QuickLinksApi>(`${environment.apiUrl}/get_quick_links`).pipe(
      map((res) => res.data)
    );
  }
  getQuickLinkAll(): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/get_quick_links`)
  }

  getAlumniLinkAll(): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/get_alumni_links`)
  }

  
}
